module.exports = __webpack_public_path__ + "img/address.617ab483.png";